<template>
  <div class="card mb-4">
    <div class="card-header bg-info text-light">
      User Management
    </div>
    <div class="card-body">
      <button type="button" class="btn btn-success" data-toggle="modal" data-target="#newUserFormDialog"><i class="fa fa-plus"></i>&nbsp;&nbsp;Add User</button>
      <div class="table-responsive">
        <table class="table mt-4">
          <thead>
            <tr>
              <th scope="col" style="width:50px; min-width:50px"></th>
              <th scope="col" style="width:225px; min-width:175px">Name</th>
              <th scope="col" style="width:300px; min-width:200px">Email</th>
              <th scope="col" style="width:100px; min-width:100px">Admin</th>
              <th scope="col" style="width:100px; min-width:100px">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" v-bind:key="user.id">
              <td><i class="fa fa-user-circle text-secondary" style="font-size: 1.5em"></i></td>
              <td>{{ user.fname}} {{ user.lname }}</td>
              <td>{{ user.email }}</td>
              <td>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" :id="'switch_'+user.id" v-model="user.orgadmin" @change="toggleAdmin($event, user.id)">
                  <label class="custom-control-label" :for="'switch_'+user.id"></label>
                </div>
              </td>
              <td>
                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#editUserDialog" @click="setUserOrgApps(user.id)"><i class="fa fa-wrench"></i></button>&nbsp;
                <button type="button" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#confirmRemoveUserDialog" @click="setSelectedOrgUserid(user.id)"><i class="fa fa-trash-alt"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" id="newUserFormDialog" tabindex="-1" role="dialog" aria-labelledby="newUserFormDialogLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newUserFormDialogLabel">Add New User</h5>
            <button @click="onCloseNewUserFormDialog()" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <NewUserForm ref="NewUserForm" @new-user-added="onNewUserAdded" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="confirmRemoveUserDialog" tabindex="-1" role="dialog" aria-labelledby="confirmRemoveUserDialogLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmRemoveUserDialogLabel">Confirm Remove User</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to remove this user from your organization?</p>
            <button type="button" class="btn btn-danger btn-sm" @click="removeSelectedOrgUser()">Remove</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="editUserDialog" tabindex="-1" role="dialog" aria-labelledby="editUserDialogLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editUserDialogLabel">Edit User</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive table-bordered">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th scope="col" style="width:90%;" colspan="2">Apps</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="app in allUserOrgApps" v-bind:key="app.id">
                    <td style="text-align: center;">
                      <input type="checkbox" :value="app.id" v-model="app.checked" @click="onCheckUserOrgApp(app)">
                    </td>
                    <td>
                      <h6 style="font-weight: bold">{{ app.name }}</h6>
                      <p class="small mb-0">{{ app.description }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Org from '@/structs/Org'
import NewUserForm from '@/components/NewUserForm.vue'

export default {
  name: 'OrgUsersAdmin',
  computed: {
    ...mapGetters('auth', ['currentOrg'])
  },
  components: {
    'NewUserForm': NewUserForm
  },
  data () {
    return {
      org: new Org(),
      users: [],
      selectedOrgUserid: null,
      allOrgApps: [],
      allUserOrgApps: []
    }
  },
  created () {
    this.setOrg()
    this.setOrgUsers()
  },
  methods: {
    ...mapActions('org', ['fetchUsers', 'fetchOrgApps']),
    ...mapActions('user', ['addGroups', 'removeGroups', 'removeUser', 'fetchUserApps', 'addUserApps', 'removeUserApps']),
    setOrg () {
      this.org = Object.assign(new Org(), this.currentOrg)
    },
    setOrgUsers () {
      this.fetchUsers().then(users => { this.users = users }).then(this.setOrgAdmins)
    },
    setSelectedOrgUserid (userid) {
      this.selectedOrgUserid = userid
    },
    removeSelectedOrgUser () {
      const userid = this.selectedOrgUserid
      this.removeUser({ userid: userid })
        .then(() => { this.users = this.users.filter(user => { return user.id !== userid }) })
        .then(() => { document.getElementById('confirmRemoveUserDialog').querySelector('.close').click() })
        .catch((err) => { console.log(err) })
    },
    onNewUserAdded (newuser) {
      this.users.push(newuser)
    },
    onCloseNewUserFormDialog () {
      // not "best practice" to do this through refs (tightly coupling components), but it makes sense in this instance
      this.$refs.NewUserForm.clearForm()
    },
    toggleAdmin (event, userid) {
      const user = this.users.find(user => { return user.id === userid })
      let req = null
      if (event.target.checked) {
        req = this.addGroups({ userid: user.id, groupnames: ['ADMINS', 'TPM_ADMINS'] }).then(() => { user.orgadmin = true })
      } else {
        req = this.removeGroups({ userid: user.id, groupnames: ['ADMINS', 'TPM_ADMINS'] })
      }

      req.then(() => { user.orgadmin = event.target.checked }).catch(() => { user.orgadmin = !event.target.checked })
    },
    setUserOrgApps (userid) {
      let self = this
      this.allUserOrgApps = []
      let p
      if (!this.allOrgApps || this.allOrgApps.length === 0) {
        p = this.fetchOrgApps().then((allOrgApps) => { this.allOrgApps = allOrgApps })
      } else {
        p = Promise.resolve()
      }

      p.then(() => {
        return self.fetchUserApps({ userid: userid })
      }).then((allUserApps) => {
        let userAppIds = allUserApps.map(a => { return a.id })
        self.allUserOrgApps = self.allOrgApps.map(a => {
          a.checked = (userAppIds.indexOf(a.id) !== -1)

          return a
        })

        self.setSelectedOrgUserid(userid)
      }).catch((err) => { console.log(err) })
    },
    onCheckUserOrgApp (app) {
      if (!app.checked) {
        this.addUserApps({ userid: this.selectedOrgUserid, appids: app.id })
      } else {
        this.removeUserApps({ userid: this.selectedOrgUserid, appids: app.id })
      }
    }
  }
}

</script>
